angular.module('lf.common')

.directive('lfFocusOn', function () {
  return function (scope, elem, attr) {
    scope.$on('focusOn', function (e, name) {
      if(name === attr.name) {
        elem[0].focus();
      }
    });
  };
});
